import {stringify} from "comment-json";
import {ElementsTree} from "../../../../model/ElementsTree";
import {Graph} from "../../../../model/Graph";
import {Playshot} from "../../../../model/Playshot";
import {fqcn, fqcnWithDefaultService} from "../../../cody-wizard/node/fqcn";
import {getNodeIdFromProophBoardDescription} from "../../descriptions";
import {PlayshotChanged} from "../PlayshotChanged";
import {PlayCommandRegistry} from "./command-definitions";
import {CommandAdded} from "./CommandAdded";
import {CommandMetadataChanged} from "./CommandMetadataChanged";
import {CommandRenamed} from "./CommandRenamed";
import {CommandRemoved} from "./CommandRemoved";

export const compareCommands = (oldPlayshot: Playshot, newPlayshot: Playshot, graph: Graph, elementsTree: ElementsTree): PlayshotChanged[] => {
  const oldCommands: PlayCommandRegistry = oldPlayshot.playConfig.commands;
  const newCommands: PlayCommandRegistry = newPlayshot.playConfig.commands;

  const changeSet: PlayshotChanged[] = [];

  const oldNames = Object.keys(oldCommands);
  const newNames = Object.keys(newCommands);

  const commandsToRemove: string[] = oldNames.filter(oldName => !newNames.includes(oldName));
  const commandsToAdd: string[] = newNames.filter(newName => !oldNames.includes(newName));

  const changedCommands: string[] = newNames.filter(newName => {
    if(commandsToAdd.includes(newName)) {
      return false;
    }

    const oldCommand = oldCommands[newName];
    const newCommand = newCommands[newName];
    const oldRules = oldPlayshot.playConfig.commandHandlers[newName] || [];
    const newRules = newPlayshot.playConfig.commandHandlers[newName] || [];


    return stringify(oldCommand) !== stringify(newCommand) || stringify(oldRules) !== stringify(newRules);
  })

  commandsToAdd.forEach(cmdNameToAdd => {
    const cmdToAdd = newCommands[cmdNameToAdd];

    const existingNode = graph.getNode(getNodeIdFromProophBoardDescription(cmdToAdd.desc));

    if(existingNode) {
      const oldName = fqcnWithDefaultService(existingNode, oldPlayshot.playConfig.defaultService);

      const oldInfo = oldPlayshot.playConfig.commands[oldName];

      if(oldInfo) {
        changeSet.push(new CommandRenamed(cmdNameToAdd, getNodeIdFromProophBoardDescription(cmdToAdd.desc), cmdToAdd, oldInfo, newPlayshot, oldPlayshot));
        return;
      }
    }

    changeSet.push(new CommandAdded(cmdNameToAdd, getNodeIdFromProophBoardDescription(cmdToAdd.desc), cmdToAdd, newPlayshot));
  })

  changedCommands.forEach(cmdNameToUpdate => {
    const cmdToUpdate = newCommands[cmdNameToUpdate];

    changeSet.push(new CommandMetadataChanged(cmdNameToUpdate, getNodeIdFromProophBoardDescription(cmdToUpdate.desc), cmdToUpdate, newPlayshot, oldPlayshot));
  });

  commandsToRemove.forEach(cmdNameToRemove => {
    const oldCommand = oldCommands[cmdNameToRemove];

    changeSet.push(new CommandRemoved(cmdNameToRemove, getNodeIdFromProophBoardDescription(oldCommand.desc), oldCommand, oldPlayshot));
  })

  return changeSet;
}
